import React from "react";
import styles from "../styles/QR.module.css";
import Header from "../components/Header";
import pic from "../assets/qr2.png";
import payment from "../assets/qr3.png";
import confirm from "../assets/confirm.png";
import view from "../assets/qr4.png";
import termin from "../assets/generateQR.png";
import terminal from "../assets/scanPay.png";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const QrPayment = () => {
  return (
    <div>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p className={styles.msmesLabel}>ArifQR</p>
            <h1 className={styles.heroTitle}>What is ArifQR</h1>
            <p style={{ fontSize: "16px", color: "back" }}>
              ArifQR is a fast, secure, and convenient QR code payment solution
              designed to simplify transactions for businesses and customers.
              Whether you run a small shop, a restaurant, or an enterprise,
              ArifQR enables cashless payments with just a scan-no need for
              physical cash or card terminals.
            </p>

            <Link to="/ContactUs">
              <button className={styles.contactButton}>Contact Us →</button>
            </Link>
          </div>
          <div className={styles.heroImage}>
            <div className={styles.imageWithButtons}>
              <img
                style={{
                  borderRadius: "40px",
                  height:"auto",
                  maxWidth: "450px",
                  // marginRight:"150px",
                }}
                src={pic}
                alt="Payment terminal in a shop"
              />
            </div>
          </div>
        </div>

      </div>
      <div className={styles.helpingSection}>
        <div className={styles.helpingText}>
          <p style={{ color: "green", fontSize: "1.5em" }}> WHY CHOOSE US</p>
          <h2 style={{ fontSize: "2em", margin:'0' }} className={styles.helpingTitle}>
            Why Choose ArifQR
          </h2>
          <Link to="/become-a-partner">
            <button className={styles.primaryButton}>Become a Merchant →</button>
          </Link>
        </div>
      </div>

      <section
        className={styles.dev}
        style={{
          display: "flex",
          justifyContent: "center",
          // display:'flex',
      
         
      
          alignItems: "center",
          // gap: "2rem",
          marginTop: "250px",
        }}
      >
        <div
          className={styles.viewText}
          // style={{ flex: 1, marginLeft: "100px" }}
        >
          <h3 style={{ fontSize: "1.3em", marginBottom:"0", marginTop:"0" }}>
            <span className={styles.icon}>✦</span>
Dynamic & Static QR Codes
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
          Generate real-time (amount-based) or reusable static QR codes for any use case.
          </p>

          <div className={styles.second}>
            <h3 style={{ fontSize: "1.3em", marginBottom:"0", marginTop:"0" }}>
              <span className={styles.icon}>✦</span>Card & Wallet Integration
            </h3>
            <p style={{ color: "black", fontSize: "1em" }}>
            Accept payments from debit cards, Wallets , and other mobile money platforms all through a single QR.
            </p>
          </div>

          <h3 style={{ fontSize: "1.3em", marginBottom:"0", marginTop:"0" }}>
            <span className={styles.icon}>✦</span>Instant Confirmation & E-Receipts
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
          Real-time success alerts and automated receipt delivery via SMS/email.
          </p>

          <h3 style={{ fontSize: "1.3em", marginBottom:"0", marginTop:"0" }}>
            <span className={styles.icon}>✦</span>Transaction Analytics
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>

Track payment volume, source (card, wallet), and frequency through the merchant dashboard
          </p>

          <h3 style={{ fontSize: "1.3em", marginBottom:"0", marginTop:"0" }}>
            <span className={styles.icon}>✦</span>User-Friendly
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
            Simple for both businesses and customers to use, making
            <br />
            transactions effortless.
          </p>
        </div>

        <div
          className={styles.solutionImage}
          style={{
            flexShrink: 0,
            maxWidth: "450px",
            height:'auto',
         

            position: "relative",
            display: "inline-block",
          }}
        >
          <img
            src={payment}
            alt="feature payment"
            style={{
              width: "500px",
              // marginRight: "100px",
              height: "350px",
              display: "block",
              borderRadius: "35px",
              border: "6px solid #8fbc8f",
            }}
          />
        </div>
      </section>

      <section className={styles.howItWorksSection}>
        <p style={{ fontSize: "1.3em" }} className={styles.subtitle}>
          TAKE YOUR FIRST STEP TO OUR QR CODE SYSTEM
        </p>
        <h2 className={styles.title}>How it works?</h2>

        <div className={styles.stepsContainer}>
          <div className={styles.stepCard}>
            <p style={{ fontSize: "1.5em" }} className={styles.stepNumber}>
              STEP 1
            </p>
            <h3 className={styles.stepTitle}>Generate a QR Code</h3>
            <p className={styles.stepDescription}>
              Merchants can create and display unique QR codes for payments.
            </p>
            <img
              className={styles.stepImage}
              src={termin}
              alt="Generate QR Code"
            />
          </div>

          <div className={styles.stepCard}>
            <p style={{ fontSize: "1.5em" }} className={styles.stepNumber}>
              STEP 2
            </p>
            <h3 className={styles.stepTitle}>Scan & Pay</h3>
            <p className={styles.stepDescription}>
              Customers scan the QR code using their mobile<br/> banking or payment
              app.
            </p>
            <img
              className={styles.stepImage}
              src={terminal}
              alt="Scan and Pay"
            />
          </div>

          <div className={styles.stepCard}>
            <p style={{ fontSize: "1.5em" }} className={styles.stepNumber}>
              STEP 3
            </p>
            <h3 className={styles.stepTitle}>Confirm & Complete</h3>
            <p className={styles.stepDescription}>
              The payment is instantly processed, and <br/>both parties receive
              confirmation.
            </p>
            <img
              className={styles.newImage}
              src={confirm}
              alt="Confirm and Complete"
            />
          </div>
        </div>
      </section>

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "2em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                It Starts With Your Business
                <br />
                Account
              </h2>
              <p style={{ fontSize: "0.9em" }}>
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
                Join our merchants.
              </p>
              <Link to="/become-a-merchant">
                <button
                  className={styles.but}
                  style={{
                    backgroundColor: "#fff",
                    color: "green",
                    border: "none",
                    padding: "15px 30px",
                    borderRadius: "5px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Register Now →
                </button>
              </Link>
            </div>

            {/* Image Side */}
            <div className={styles.Imageside}
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={view} // your actual image path
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default QrPayment;
